<script setup>
let observer
const active = ref()
const slugs = ref()

/**
 * Observer
 */
function createObserver() {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          active.value = entry.target.dataset.slug
        }
      })
    },
    {
      rootMargin: '-50% 0px',
    }
  )

  const sections = document.querySelectorAll('.section')
  sections.forEach((el) => {
    observer.observe(el)
  })
}

function isActive(slug) {
  return slug === active.value
}

function isPast(slug) {
  const currentIndex = slugs.value.findIndex(
    (testSlug) => testSlug === active.value || 0
  )
  const sectionIndex = slugs.value.findIndex((testSlug) => testSlug === slug)
  return currentIndex > sectionIndex
}

function getSlugs() {
  slugs.value = [...document.querySelectorAll('.section')].map(
    (el) => el.dataset.slug
  )
}

onMounted(async () => {
  await nextTick()
  createObserver()
  getSlugs()
})

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>

<template>
  <ol class="tick-pagination">
    <li
      v-for="slug in slugs"
      :key="slug"
      class="tick-pagination__tick"
      :class="{
        'tick-pagination__tick--active': isActive(slug),
        'tick-pagination__tick--past': isPast(slug),
      }"
    >
      <span class="u-visually-hidden">{{ slug }}</span>
    </li>
  </ol>
</template>

<style lang="scss">
@import 'styles/utils/variables';

.tick-pagination {
  overflow: hidden;

  &__tick {
    background: $brand-white;
    width: 14px;
    height: 2px;
    transform: translateX(-11px);
    transition: background 0.3s ease, transform 0.3s ease;

    &:not(:last-child) {
      margin-bottom: 6px;
    }

    &--active {
      background: linear-gradient(
        to right,
        $brand-magenta 25%,
        rgba($brand-magenta, 0) 125%
      );
      transform: translateX(0);
    }
    &--past {
      background: $brand-magenta;
    }
  }
}
</style>
